import { render } from "./DinhMucCoDinhVatTuTable.vue?vue&type=template&id=c3813c76&ts=true"
import script from "./DinhMucCoDinhVatTuTable.vue?vue&type=script&lang=ts"
export * from "./DinhMucCoDinhVatTuTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__